import { venueApi } from './api'
import { useDataRead, DataHookOptions, useDataList } from '@hooks/data'
import { Venue, VenueDaySettings } from 'types/model'
import { AppConfig } from 'types/model/appConfig'
import { VenueLayout, VenueLayoutSection, VenueLayoutTable } from 'types/model/venue-layout'

function getPath(append?: number | string) {
  return append ? venueApi.pathPrefix.concat(`${append}`) : venueApi.pathPrefix
}

function versionlessPath(append?: number | string) {
  return append ? `/venue${append}` : '/venue'
}

export function useVenue(venue: string | null, options?: DataHookOptions<Venue>) {
  const path = venue ? getPath(`/${venue}`) : null
  return useDataRead<Venue>(venueApi, path, options)
}

export function useAppConfig(venue: string, options?: DataHookOptions<AppConfig>) {
  return useDataRead<AppConfig>(venueApi, getPath(`/${venue}/app-config`), options)
}

export function useVenueDaySettings(
  venue: string | null,
  dayId: string | null,
  options?: DataHookOptions<VenueDaySettings>
) {
  const path = venue && dayId ? getPath(`/${venue}/day-settings/${dayId}`) : null
  return useDataRead<VenueDaySettings>(venueApi, path, options)
}

export function useVenueDaySettingsList(
  venue: string | null,
  options?: DataHookOptions<VenueDaySettings>
) {
  const path = venue ? getPath(`/${venue}/day-settings`) : null
  return useDataRead<VenueDaySettings>(venueApi, path, options)
}

export function useVenueLayouts(venue: string | null, options?: DataHookOptions<VenueLayout[]>) {
  const path = venue ? versionlessPath(`/${venue}/layout`) : null
  return useDataList<VenueLayout>(venueApi, path, options)
}

export function useVenueSections(
  venue: string | null,
  options?: DataHookOptions<VenueLayoutSection[]>
) {
  const path = venue ? versionlessPath(`/${venue}/layout-section`) : null
  return useDataList<VenueLayoutSection>(venueApi, path, options)
}

export function useVenueTables(
  venue: string | null,
  options?: DataHookOptions<VenueLayoutTable[]>
) {
  const path = venue ? versionlessPath(`/${venue}/layout-table`) : null
  return useDataList<VenueLayoutTable>(venueApi, path, options)
}
